import { render } from "./TextLogoComponent.vue?vue&type=template&id=c8350dbc&scoped=true"
import script from "./TextLogoComponent.vue?vue&type=script&lang=js"
export * from "./TextLogoComponent.vue?vue&type=script&lang=js"

import "./TextLogoComponent.vue?vue&type=style&index=0&id=c8350dbc&scoped=true&lang=css"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8350dbc"]])

export default __exports__